// extracted by mini-css-extract-plugin
export default {"section":"StarshipsList_section__eh7QN","starship-list":"StarshipsList_starship-list__oNlF4"};